import type { IntlShape } from 'react-intl-next';

import {
	DefaultExtensionProvider,
	type ExtensionProvider,
} from '@atlaskit/editor-common/extensions';

import { type Snippet } from '../snippetTypes.ts';

import { snippetExtensionManifest } from './snippetExtensionManifest.tsx';

export const snippetExtensionProvider = (
	intl: IntlShape,
	snippets: Snippet[],
	onOpenTemplatePanel?: () => void,
): ExtensionProvider => {
	if (!onOpenTemplatePanel && (!snippets || snippets.length === 0)) {
		return new DefaultExtensionProvider([]);
	}

	const manifest = snippetExtensionManifest({
		snippets: snippets || [],
		intl,
		onOpenTemplatePanel,
	});

	return new DefaultExtensionProvider([manifest]);
};
